import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataFormatService {

  months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  constructor() { }

  formatDate(inputDate: string|null) {
    if (!inputDate) {
      return null;
    }
    let
      output = new Date(inputDate).toLocaleDateString('en-GB'),
      inputAsArr = output.split("/"),
      outputDate = inputAsArr[0] + "-" + this.months[Number(inputAsArr[1]) - 1] + "-" + inputAsArr[2];
    return outputDate;
  }

  getDiffBtwDates(fromDate: string|null, toDate: string|null, format?: 'days' | 'months' | 'years'): number|null {

    if (!fromDate || !toDate) {
      return null;
    }

    let
      _fromDate = new Date(fromDate).getTime(), // as millisecond
      _toDate = new Date(toDate).getTime(), // as millisecond
      diffTime = Math.abs(_toDate - _fromDate),
      aSec = 1000, // 1000 millisecond
      aMin = 60 * aSec,
      aHr = 60 * aMin,
      aDay = 24 * aHr,
      diffDays = Math.ceil(diffTime / aDay),
      diffMonths = Math.floor(diffDays / 7),
      diffYears: number;

    if (format === 'months') {
      return diffMonths;
    } else if (format === 'years') {
      diffYears = (_toDate - _fromDate) / 31536000000; // milliseconds in a year
      diffYears = Number(diffYears.toFixed(1));
      return diffYears;
    } else {
      return diffDays;
    }
  }
}
